import classNames from "classnames/bind";
import { useCallback, useState } from "react";
import Button from "../../../components/Button/Button";
import Toast from "../../../components/Toast";
import axiosClient from "../../../services/axiosClient";
import { isValidateConfirm, isValidatePassword } from "../../../utils";
import styles from "./ChangePassword.module.css";
import FormItem from "./FormItem/FormItem";
import { CheckIcon } from "../../../components/Icons/Icons";
import { useTranslation } from "react-i18next";


const cx = classNames.bind(styles);

function ChangePassword() {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [submit, setSubmit] = useState(false);
    const { t } = useTranslation();
    const handleTypeOldPassword = (data) => {
        setOldPassword(data);
        setSubmit(false);
    }
    const handleTypeNewPassword = (data) => {
        setNewPassword(data);
        setSubmit(false);
    }

    const handleTypeConfirmPassword = (data) => {
        setConfirmPassword(data);
        setSubmit(false);
    }
    const changePassword = useCallback(async () => {
        try {
            await axiosClient.put('/authenticator/changePassword/', {
                old_password: oldPassword,
                new_password: newPassword,
            })
            localStorage.clear();
            sessionStorage.clear();
            window.location.reload();
            Toast.open(t("changePassword.changePassSuccess"), 'success')
        } catch (e) {
            Toast.open(t("changePassword.canNotChangePass"), 'danger')
        }
    }, [oldPassword, newPassword])
    const handleSubmitForm = () => {
        setSubmit(true)
        if (
            isValidatePassword(newPassword) &&
            isValidatePassword(confirmPassword) &&
            isValidateConfirm(newPassword, confirmPassword)
        ) {
            changePassword();
        } else {
            Toast.open(t("changePassword.canNotChangePass"), 'danger')
        }
    }
    return (
        <form className={cx('form-change-password')} onSubmit={handleSubmitForm}>
            <FormItem
                label={t("changePassword.currentPass")}
                name={'oldPassword'}
                values={oldPassword}
                onChange={handleTypeOldPassword}
                type={'password'}
                rules={[
                    {
                        isRequire: true,
                        mess: t("changePassword.emptyError")
                    },
                ]}
                onSubmit={submit}
            />
            <FormItem
                label={t("changePassword.newPass")}
                name={'newPassword'}
                values={newPassword}
                onChange={handleTypeNewPassword}
                type={'password'}
                warning={t("changePassword.title")}
                rules={[
                    {
                        isRequire: true,
                        mess: t("changePassword.newPassEmtyError")
                    },
                    {
                        newPass: oldPassword,
                        mess: t("changePassword.newPassSameCurrentError")
                    },
                ]}
                onSubmit={submit}
            />
            <div className={cx('confirm-pass')}>
                <FormItem
                    label={t("changePassword.confirmPass")}
                    name={'confirmPassword'}
                    values={confirmPassword}
                    onChange={handleTypeConfirmPassword}
                    type={'password'}
                    rules={[
                        {
                            isRequire: true,
                            mess: t("changePassword.confirmPassEmtyError")
                        },
                        {
                            confirm: newPassword,
                            mess: t("changePassword.confirmPassNotSameError")
                        }
                    ]}
                    onSubmit={submit}
                />
                {(isValidateConfirm(newPassword, confirmPassword)) && <div className={cx('icon-check')}><CheckIcon /></div>}
            </div>
            <div className={cx('button-change')}>
                <Button
                    onClick={handleSubmitForm}
                    title={t("changePassword.accept")}
                />
            </div>
        </form>
    )
}

export default ChangePassword;